import UserInfoAvatar from '@Components/UserInfoAvatar'
import Button from '@Components/Buttons/Button'
import SubmitButton from '@App/kit/fields/SubmitButton'
import React from 'react'
import { UserInfoType } from '@Entities/schemas/user/user-info-schema'

interface TopSectionProps {
    startedProfileInfo: Partial<UserInfoType>
    setNonEditable(): void
    disabled: boolean
}

const TopSection = (props: TopSectionProps) => {
    const { startedProfileInfo, setNonEditable, disabled } = props
    return (
        <div className="profile-info">
            <UserInfoAvatar userInfo={startedProfileInfo} />
            <div className="edit-buttons">
                <Button mainColor={false} type="primary" onClick={setNonEditable}>
                    Cancel
                </Button>
                <SubmitButton label="Save" disabled={disabled} />
            </div>
        </div>
    )
}
export default TopSection
